var crypto = require('crypto');
var algorithm = 'aes-256-ctr';
function Cryptr(secret) {
  if (!secret || typeof secret !== 'string') {
    throw new Error('Cryptr: secret must be a non-0-length string');
  }
  var key = crypto.createHash('sha256').update(String(secret)).digest();
  this.encrypt = function encrypt(value) {
    if (value == null) {
      throw new Error('value must not be null or undefined');
    }
    var iv = crypto.randomBytes(16);
    var cipher = crypto.createCipheriv(algorithm, key, iv);
    var encrypted = cipher.update(String(value), 'utf8', 'hex') + cipher.final('hex');
    return iv.toString('hex') + encrypted;
  };
  this.decrypt = function decrypt(value) {
    if (value == null) {
      throw new Error('value must not be null or undefined');
    }
    var stringValue = String(value);
    var iv = Buffer.from(stringValue.slice(0, 32), 'hex');
    var encrypted = stringValue.slice(32);
    var legacyValue = false;
    var decipher;
    try {
      decipher = crypto.createDecipheriv(algorithm, key, iv);
    } catch (exception) {
      if (exception.message === 'Invalid IV length') {
        legacyValue = true;
      } else {
        throw exception;
      }
    }
    if (!legacyValue) {
      return decipher.update(encrypted, 'hex', 'utf8') + decipher.final('utf8');
    }
    var legacyIv = stringValue.slice(0, 16);
    var legacyEncrypted = stringValue.slice(16);
    decipher = crypto.createDecipheriv(algorithm, key, legacyIv);
    return decipher.update(legacyEncrypted, 'hex', 'utf8') + decipher.final('utf8');
  };
}
module.exports = Cryptr;